@if(data().project; as project) {
<pane-card>
    <card-content ngProjectAs="card-main-content">
        <label class="mb-2 d-block primary-text">{{project.name()}}</label>
        <div class="export-package">

            <checkbox 
                innerClass="primary-text"
                [checked]="applicableStandards()" 
                (change)="onChecked($event, FIELDS.APPLICABLE_STANDARDS)"
                [id]="FIELDS.APPLICABLE_STANDARDS">
                Applicable Standards
            </checkbox>

            <checkbox 
                innerClass="primary-text"
                [checked]="serviceMatrix()" 
                (change)="onChecked($event, FIELDS.SERVICE_MATRIX)"
                [id]="FIELDS.SERVICE_MATRIX">
                Room Data Matrix
            </checkbox>

            <checkbox 
                innerClass="primary-text"
                [checked]="roomSummary()" 
                (change)="onChecked($event, FIELDS.ROOM_SUMMARY)"
                [id]="FIELDS.ROOM_SUMMARY">
                Room Data Sheets
            </checkbox>



            <!-- <checkbox 
                [checked]="revitModels()" 
                (change)="onChecked($event, FIELDS.REVIT_MODELS)"
                [id]="FIELDS.REVIT_MODELS">
                Revit Models
            </checkbox> -->

            <checkbox 
                innerClass="primary-text"
                [checked]="associatedDocuments()" 
                (change)="onChecked($event, FIELDS.ASSOCIATED_DOCUMENTS)"
                [id]="FIELDS.ASSOCIATED_DOCUMENTS">
                Supporting Documentation
            </checkbox>

            <hr class="text-muted">
            <!-- Info Note -->
            <div>
                <svg-icon class="me-2" key="info-stroke-icon" fontSize="16px"></svg-icon>
                <span class="text-muted fs-6">You will be notified once your exported zip file is ready for download.</span>
            </div>
        </div>

     



    </card-content>
    <card-content #cardBottom ngProjectAs="card-bottom-content">
      <div class="d-flex gap-2 mb-3">
        <div class="flex-fill">
             <is-busy-button id="button1" 
                    (execute)="exportCommand.execute()"
                    [isBusy]="exportCommand.isBusy()"
                    [disabled]="false"
                    css="btn w-100 clip3 corner position-relative primary-border secondary-bg secondary-text-100 font-4 rounded-0 py-2">
                <span>Export</span>
            </is-busy-button>
        </div>
        <div  class="flex-fill">
            <is-busy-button id="button3" 
                        (execute)="cancelCommand.execute()"
                        [disabled]="false" 
                        css="btn w-100 clip3 corner position-relative primary-border primary-text-100 font-4 rounded-0 py-2">
                    <span>Cancel</span>
            </is-busy-button>
        </div> 
      </div>
        
    </card-content>
</pane-card>

}